import { CourseUserViewModel } from "../coursesApiSlice";
import CourseUsersTable from "./CourseUsersTable";

interface CourseTeachersProps {
	teachers: CourseUserViewModel[];
}

export default function CourseTeachersSection(props: CourseTeachersProps) {
	return (
		<section>
			<hr className="my-6" />
			<h2>Teachers</h2>
			<CourseUsersTable users={props.teachers} displayLength={3} isTeacherTable={true} />
		</section>
	);
}
